export default "__VITE_ASSET__Df3g8yiR__"